import {
    AppBar,
    Backdrop,
    BottomNavigation,
    BottomNavigationAction,
    Box,
    Button,
    Card,
    CardContent,
    CardHeader,
    Chip,
    CircularProgress,
    Collapse,
    Container,
    Divider,
    FormControl,
    FormControlLabel,
    Grid,
    Hidden,
    IconButton,
    InputLabel,
    Link,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Menu,
    MenuItem,
    MobileStepper,
    Select,
    Snackbar,
    StepContent,
    StepLabel,
    SwipeableDrawer,
    Switch,
    Toolbar,
    Typography,
} from '@material-ui/core';
import { useState, useEffect } from 'react';
import AdminLogin from './AdminLogin';
import AdminLogin_new from './AdminLogin_new';
import MembersSearch from './MembersSearch';
import { ForecastsController } from './ForecastsController';
import ActionButton from './ActionButton';
import DoneIcon from '@material-ui/icons/Done';
import CloseIcon from '@material-ui/icons/Close';
import Skeleton from '@material-ui/lab/Skeleton';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import EmailOutlinedIcon from '@material-ui/icons/EmailOutlined';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import LinkOutlinedIcon from '@material-ui/icons/LinkOutlined';
import CreditCardOutlinedIcon from '@material-ui/icons/CreditCardOutlined';
import LocalAtmOutlinedIcon from '@material-ui/icons/LocalAtmOutlined';
import AutorenewOutlinedIcon from '@material-ui/icons/AutorenewOutlined';
import LocalPhoneOutlinedIcon from '@material-ui/icons/LocalPhoneOutlined';
import WbSunnyOutlinedIcon from '@material-ui/icons/WbSunnyOutlined';

import PaymentFormDialog from './PaymentFormDialog';
import AddCustomerDialog from './AddCustomerDialog';
import AddInvoiceDialog from './AddInvoiceDialog';
import ParkingCardsDialog from './ParkingCardsDialog';
import { makeStyles } from '@material-ui/core/styles';
import copyToClipboard from 'copy-to-clipboard';
import Alert from '@material-ui/lab/Alert';
import usePricelist from './usePricelist';
import useSecurity from './useSecurity';
import { DescriptionOutlined, KeyboardArrowLeft, KeyboardArrowRight, SearchOutlined } from '@material-ui/icons';

function AdminController() {
    const apiDomain =
        process.env.NODE_ENV !== 'development' ? '/api' : 'http://' + window.location.hostname + ':9000/api';
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [authenticatedUserEmail, setAuthenticatedUserEmail] = useState('');
    const [idToken, setIdToken] = useState('');
    const [customerId, setCustomerId] = useState('');
    const [customerFullname, setCustomerFullName] = useState('');
    const [customerEmail, setCustomerEmail] = useState('');
    const [customerStatus, setCustomerStatus] = useState({});
    const [customerParkingCards, setCustomerParkingCards] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingInvoices, setLoadingInvoices] = useState(false);
    const [loadingMemberStatus, setLoadingMemberStatus] = useState(false);

    const [apiResponse, setApiResponse] = useState({});
    const [error, setError] = useState('');
    const [stage, setStage] = useState('');

    const [invoices, setInvoices] = useState([]);
    const [memberCardExpanded, setMemberCardExpanded] = useState(false);
    const [paymentFormOpen, setPaymentFormOpen] = useState(false);
    const [paymentInvoiceNo, setPaymentInvoiceNo] = useState('');
    const [paymentInvoiceAmount, setPaymentInvoiceAmount] = useState(0);
    const [paymentType, setPaymentType] = useState('');

    const [registerParkingCardsFormOpen, setRegisterParkingCardsFormOpen] = useState(false);

    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarType, setSnackbarType] = useState('success');

    const [addCustomerFormOpen, setAddCustomerFormOpen] = useState(false);
    const [speedDialOpen, setSpeedDialOpen] = useState(false);
    const { pricelist, setPricelistIdToken } = usePricelist();
    const [addInvoiceFormOpen, setAddInvoiceFormOpen] = useState(false);
    const { security, setSecurityUser, isSecurityLoading, setSecurityIdToken } = useSecurity();
    const defaultView = process.env.NODE_ENV === 'development' ? 2 : 0;
    const [view, setView] = useState(defaultView);
    const [loadingAllInvoices, setLoadingAllInvoices] = useState(false);
    const [allInvoices, setAllInvoices] = useState([]);
    const [allInvoicesPage, setAllInvoicesPage] = useState(1);
    const [allInvoicesHasMorePage, setAllInvoicesHasMorePage] = useState(false);
    const [showInvoices, setShowInvoices] = useState([]);
    const [filterInvoicesMemberships, setFilterInvoicesMemberships] = useState(true);
    const [filterInvoicesParking, setFilterInvoicesParking] = useState(true);
    const [filterInvoicesAcademy, setFilterInvoicesAcademy] = useState(true);
    const [filterInvoicesUnpaid, setFilterInvoicesUnpaid] = useState(true);
    const [invoicesFilter, setInvoicesFilter] = useState('all');

    useEffect(() => {
        //setCustomerId("aaaa");
        //setCustomerFullName("Alistair Wark");
    }, []);
    const useStyles = makeStyles((theme) => ({
        backdrop: {
            zIndex: theme.zIndex.drawer + 1,
            color: '#fff',
        },
        fab: {
            position: 'absolute',
            bottom: theme.spacing(2),
            right: theme.spacing(2),
        },
        bottomNav: {
            width: '100%',
            position: 'fixed',
            bottom: 0,
        },
    }));

    const classes = useStyles();

    const authenticationChanged = (props) => {
        setIsAuthenticated(props.isAuthenticated);
        setIdToken(props.idToken);
        setAuthenticatedUserEmail(props.email);
        setSecurityIdToken(props.idToken);
        setSecurityUser(props.email);
    };

    const customerSelected = (props) => {
        const newCustomerId = props.customerId;
        if (newCustomerId !== customerId) {
            setCustomerFullName(props.fullName);
            setCustomerId(newCustomerId);
            setCustomerEmail(props.email);
        }
    };
    useEffect(() => {
        if (!security.basic && security.forecasts) {
            setView(2);
        }
    }, [security]);
    useEffect(() => {
        if (customerId && customerId !== '') {
            console.log('customer id changed to' + customerId);
            loadInvoices();
            loadMemberStatus();
        }
    }, [customerId]);

    useEffect(() => {
        if (idToken !== '') {
            setPricelistIdToken(idToken);
        }
    }, [idToken]);

    useEffect(() => {
        if (view === 1 && allInvoices.length == 0) {
            loadAllInvoices();
        }
    }, [view]);

    const loadInvoices = async () => {
        setStage('loadInvoices');
        setLoadingInvoices(true);
        if (1 == 1) {
            callAPI('/members/customer/' + customerId + '/invoices');
        } else {
            await sleep(2000);
            const dummyInvoices = [];
            const url =
                'https://zohosecurepay.eu/invoice/nicosiasailingclub/secure?CInvoiceID=2-b9a40c430198b4a4a1191f96973d60446df58c9a5973a3b25c43bde52667ea4a490ecc63cad70bc03ff05d8c79fb91ca4a093b78c1b3875ee92c8d5152eb852924e989b001e5ceaf';
            dummyInvoices.push({
                invoice_id: '69196000000424498',
                status: 'sent',
                invoice_number: 'Z-00285',
                date: '2021-01-07',
                total: 100.5,
                invoice_url: url,
                balance: 100,
            });
            dummyInvoices.push({
                invoice_id: '69196000000424498',
                status: 'overdue',
                invoice_number: 'Z-00286',
                date: '2020-01-07',
                total: 99,
                invoice_url: url,
                balance: 100,
            });
            dummyInvoices.push({
                invoice_id: '69196000000424498',
                status: 'paid',
                invoice_number: 'Z-00286',
                date: '2020-01-07',
                total: 99,
                invoice_url: url,
                balance: 0,
            });
            dummyInvoices.push({
                invoice_id: '69196000000424498',
                status: 'draft',
                invoice_number: 'Z-00286',
                date: '2020-01-07',
                total: 99,
                invoice_url: url,
                balance: 100,
            });
            setInvoices(dummyInvoices);
            setLoadingInvoices(false);
        }
    };
    const loadAllInvoices = async () => {
        setLoadingAllInvoices(true);
        let filtersuffix = '';
        if (invoicesFilter !== 'all') {
            filtersuffix = `&${invoicesFilter}=true`;
        }
        fetch(
            apiDomain +
                `/members/invoices/list?rpp=10&page=${allInvoicesPage}&unpaid=${filterInvoicesUnpaid}${filtersuffix}`,
            { headers: { id_token: idToken } }
        )
            .then((res) => res.text())
            .then((res) => {
                const parsedResponse = JSON.parse(res);
                //alert(JSON.stringify(parsedResponse.page_context.has_more_page));
                setAllInvoicesHasMorePage(parsedResponse.page_context.has_more_page);
                setLoadingAllInvoices(false);
                setAllInvoices(parsedResponse.invoices);
            })
            .catch((error) => {
                console.log('error with API call');
                console.log(error);
                setError(error.message);
                setLoadingAllInvoices(false);
            });
    };

    useEffect(() => {
        if (view !== 1) {
            return;
        }
        setLoadingAllInvoices(true);
        if (allInvoicesPage === 1) {
            loadAllInvoices();
        } else {
            setAllInvoicesPage(1);
        }
    }, [filterInvoicesUnpaid, invoicesFilter]);

    useEffect(() => {
        if (view !== 1) {
            return;
        }
        setLoadingAllInvoices(true);
        loadAllInvoices();
    }, [allInvoicesPage]);

    const handleChangeFilterInvoices = async (event) => {
        setInvoicesFilter(event.target.value);
    };

    const pageHandler = async (action) => {
        if (action === 'next') {
            setAllInvoicesPage(allInvoicesPage + 1);
        } else {
            setAllInvoicesPage(allInvoicesPage - 1);
        }
    };

    const filterInvoices = async () => {
        const filteredInvoices = allInvoices.filter((invoice, index) => {
            let okForAcademy = false;
            let okForUnpaid = false;
            if (filterInvoicesAcademy) {
                if (invoiceIsAcademy(invoice)) {
                    okForAcademy = true;
                }
            } else {
                okForAcademy = true;
            }
            if (filterInvoicesUnpaid) {
                if (invoice.status !== 'paid') {
                    okForUnpaid = true;
                }
            } else {
                okForUnpaid = true;
            }
            return okForAcademy && okForUnpaid;
        });
        setShowInvoices(filteredInvoices);
        setLoadingInvoices(false);
    };

    const loadMemberStatus = () => {
        setLoadingMemberStatus(true);
        const params = `/members/status/${customerFullname}`;
        fetch(apiDomain + params, { headers: { id_token: idToken } })
            .then((res) => res.text())
            .then((res) => {
                setLoadingMemberStatus(false);
                const status = JSON.parse(res);
                setCustomerStatus(status);
                if (status.email !== '') {
                    setCustomerEmail(status.email);
                }
                setCustomerParkingCards(status.parking.cards);
            })
            .catch((error) => {
                console.log('error with API call');
                console.log(error);
                setError(error.message);
                setLoadingMemberStatus(false);
            });
    };
    const callAPI = (params) => {
        setError('');
        fetch(apiDomain + params, { headers: { id_token: idToken } })
            .then((res) => res.text())
            .then((res) => setApiResponse(JSON.parse(res)))
            .catch((error) => {
                console.log('error with API call');
                console.log(error);
                setError(error.message);
            });
    };

    useEffect(() => {
        if (stage === 'loadInvoices') {
            const inv = [];
            setInvoices([]);
            if (apiResponse && apiResponse.length) {
                apiResponse.map((item, index) => {
                    inv.push({
                        invoice_id: item.invoice_id,
                        status: item.status,
                        invoice_number: item.invoice_number,
                        date: item.date,
                        total: item.total,
                        invoice_url: item.invoice_url,
                    });
                });
                setInvoices(apiResponse);
                //console.log(JSON.stringify(apiResponse));
            }
        }
        setLoadingInvoices(false);
    }, [apiResponse]);

    function sleep(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }

    const actionButtonHandler = (action) => {
        if (action === 'customer') {
            setAddCustomerFormOpen(true);
        } else if (action === 'invoice') {
            setAddInvoiceFormOpen(true);
        }
    };

    const addCustomerFormClosed = (customer) => {
        setSpeedDialOpen(false);
        if (customer) {
            forceSelectCustomer(customer);
            if (customer.customerExisted) {
                //dont close the form so that we see the error...
            } else {
                setAddCustomerFormOpen(false);
            }
        } else {
            setAddCustomerFormOpen(false);
        }
    };
    const forceSelectCustomer = (customer) => {
        setView(0);
        customerSelected({
            customerId: customer.customerId,
            fullName: customer.fullName,
            email: customer.email,
            mobile: customer.mobile,
        });
    };

    const addInvoiceFormClosed = (invoice) => {
        setSpeedDialOpen(false);
        setAddInvoiceFormOpen(false);
        if (invoice) {
            loadInvoices();
        }
    };

    const itemActionHandler = (action, item) => {
        const invoice = view === 0 ? invoices[item.index] : allInvoices[item.index];
        setPaymentType(action);
        if (action === 'jccpayment') {
            payInvoiceConfirm(invoice.invoice_number, invoice.total);
        } else if (action === 'cashpayment') {
            payInvoiceConfirm(invoice.invoice_number, invoice.total);
        } else if (action === 'stripepayment') {
            payInvoiceConfirm(invoice.invoice_number, invoice.total);
        } else if (action === 'registerparkingcards') {
            registerParkingCardsConfirm();
        } else if (action === 'invoicelink') {
            copyToClipboard(invoice.invoice_url);
            setSnackbarMessage('Copied invoice link to your clipboard');
            setSnackbarType('success');
            setSnackbarOpen(true);
        } else if (action === 'previewinvoice') {
            window.open(
                invoice.invoice_url,
                '_blank' // <- This is what makes it open in a new window.
            );
        } else if (action === 'emailinvoice') {
            emailInvoice(invoice);
        } else if (action === 'emailreceipt') {
            emailReceipt(invoice);
        } else {
            //alert(`Unhandled action:${action} on invoice ${invoice.invoice_number}`);
        }
    };
    const emailReceipt = (invoice) => {
        const receiptNo = invoice.payments[0].payment_number;
        let params = `/members/payment/email/${receiptNo}`;
        let method = 'get';
        let head = { id_token: idToken };
        let body = null;
        fetch(apiDomain + params, { headers: head, method: method, body: body })
            .then((res) => res.text())
            .then((res) => {
                // setLoading(false);
                setSnackbarMessage('Emailed receipt ' + receiptNo + ' to ' + invoice.email);
                setSnackbarType('success');
                setSnackbarOpen(true);
            })
            .catch((error) => {
                console.log('error with API call');
                console.log(error);
                setError(error.message);
                //setLoading(false);
            });
    };
    const emailInvoice = (invoice) => {
        let params = `/members/invoice/email/${invoice.invoice_number}`;
        let method = 'get';
        let head = { id_token: idToken };
        let body = null;
        fetch(apiDomain + params, { headers: head, method: method, body: body })
            .then((res) => res.text())
            .then((res) => {
                // setLoading(false);
                setSnackbarMessage('Emailed invoice to ' + invoice.email);
                setSnackbarType('success');
                setSnackbarOpen(true);
            })
            .catch((error) => {
                console.log('error with API call');
                console.log(error);
                setError(error.message);
                //setLoading(false);
            });
    };

    const payInvoiceConfirm = (invoice_number, amount) => {
        setPaymentInvoiceNo(invoice_number);
        setPaymentInvoiceAmount(amount);
        setPaymentFormOpen(true);
    };
    const paymentFormHandler = async (props) => {
        setPaymentFormOpen(false);

        if (props) {
            setLoading(true);
            //await sleep(2000);
            const { invoice_no, zohoMethod, zohoReference, incomeAccount, amount } = props;
            let params = `/members/payment/${invoice_no}/${zohoReference}/${zohoMethod}/${incomeAccount}`;
            let method = 'get';
            let head = { id_token: idToken };
            let body = null;
            fetch(apiDomain + params, { headers: head, method: method, body: body })
                .then((res) => res.text())
                .then((res) => {
                    setLoading(false);
                    loadInvoices();
                    loadMemberStatus();
                    loadAllInvoices();
                })
                .catch((error) => {
                    console.log('error with API call');
                    console.log(error);
                    setError(error.message);
                    setLoading(false);
                });
        }
    };

    const registerParkingCardsConfirm = () => {
        setRegisterParkingCardsFormOpen(true);
    };
    const registerParkingCardsFormClosed = () => {
        setRegisterParkingCardsFormOpen(false);
        loadMemberStatus();
    };

    const telLink = `tel://${customerStatus.tel}`;
    const emailLink = `mailto:${customerEmail}`;
    let chipColor = customerStatus.status === 'Paid Member' ? 'primary' : 'default';
    chipColor = customerStatus.status === 'ex Member' ? 'secondary' : chipColor;
    chipColor = customerStatus.status === 'Non Member' ? 'secondary' : chipColor;
    let icon = <DoneIcon />;
    icon = customerStatus.status === 'Non Member' ? <CloseIcon /> : icon;
    //chipColor=(customerStatus.status==="Unpaid Member")&&"default";
    //chipColor=(customerStatus.status==="ex Member")&&"secondary";

    const handleMemberCardExpandClick = () => {
        setMemberCardExpanded(!memberCardExpanded);
    };
    return (
        <>
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={() => setSnackbarOpen(false)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert severity={snackbarType}>{snackbarMessage}</Alert>
            </Snackbar>
            <Backdrop className={classes.backdrop} open={loading || isSecurityLoading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <PaymentFormDialog
                open={paymentFormOpen}
                callback={paymentFormHandler}
                invoiceNo={paymentInvoiceNo}
                amount={paymentInvoiceAmount}
                defaultPaymentMethod={paymentType === 'jccpayment' ? 'JCC' : 'stripe'}
                paymentType={paymentType}
                security={security}
            />
            <AddCustomerDialog
                open={addCustomerFormOpen}
                onClose={addCustomerFormClosed}
                apiDomain={apiDomain}
                idToken={idToken}
            />
            <ParkingCardsDialog
                open={registerParkingCardsFormOpen}
                onClose={registerParkingCardsFormClosed}
                parkingCards={customerParkingCards}
                customerFullname={customerFullname}
                apiDomain={apiDomain}
                idToken={idToken}
            />
            <AddInvoiceDialog
                open={addInvoiceFormOpen}
                onClose={addInvoiceFormClosed}
                apiDomain={apiDomain}
                idToken={idToken}
                pricelist={pricelist}
                customerId={customerId}
                customerFullname={customerFullname}
            />
            <PageHeader
                authenticationHandler={authenticationChanged}
                security={security}
                apiDomain={apiDomain}
                searchbar={security.basic && <MembersSearch idToken={idToken} customerSelected={customerSelected} />}
            />
            <Box height="10%">&nbsp;</Box>
            <Grid container direction="column" justify="center" style={{ display: view === 0 ? '' : 'none' }}>
                <Grid>
                    <Grid item>
                        <Container>
                            {isAuthenticated && security.basic && (
                                <MembersSearch
                                    idToken={idToken}
                                    customerSelected={customerSelected}
                                    setCustomerFromOutside={customerFullname}
                                />
                            )}
                        </Container>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container direction="column" justify="center" alignContent="center">
                {view === 0 && isAuthenticated && customerId && (
                    <Container>
                        <SectionHeading title="Member Information" />
                        <Card style={{ width: 'auto' }}>
                            <CardHeader
                                title={customerFullname}
                                subheader={
                                    loadingMemberStatus ? (
                                        <Skeleton width={80} />
                                    ) : (
                                        <Chip
                                            color={chipColor}
                                            size="small"
                                            icon={icon}
                                            label={customerStatus.status}
                                        />
                                    )
                                }
                                action={
                                    <IconButton aria-label="settings" onClick={handleMemberCardExpandClick}>
                                        <ExpandMoreIcon />
                                    </IconButton>
                                }
                            ></CardHeader>
                            <Collapse in={memberCardExpanded}>
                                <CardContent>
                                    <p style={{ margin: 0, lineHeight: 1.5 }}>
                                        <div>
                                            {loadingMemberStatus && <Skeleton width={200} />}
                                            {!loadingMemberStatus && customerStatus.tel !== '' && (
                                                <>
                                                    <LocalPhoneOutlinedIcon />
                                                    <Link
                                                        href={telLink}
                                                        style={{ verticalAlign: 'super', marginLeft: '1em' }}
                                                    >
                                                        {customerStatus.tel}
                                                    </Link>
                                                    <br />
                                                </>
                                            )}
                                            <EmailOutlinedIcon />
                                            <Link
                                                href={emailLink}
                                                style={{ verticalAlign: 'super', marginLeft: '1em' }}
                                            >
                                                {customerEmail}
                                            </Link>
                                        </div>
                                    </p>
                                </CardContent>
                            </Collapse>
                        </Card>

                        <SectionHeading title="Invoices" />
                        <Card style={{ width: 'auto' }}>
                            <InvoicesPanel
                                invoices={invoices}
                                loading={loadingInvoices}
                                itemActionHandler={itemActionHandler}
                                security={security}
                            />
                        </Card>
                    </Container>
                )}
                {view === 1 && isAuthenticated && (
                    <Container>
                        <Box display="flex" justifyContent="space-between">
                            <FormControl>
                                <Select
                                    labelId="demo-simple-select-standard-label"
                                    id="demo-simple-select-standard"
                                    value={invoicesFilter}
                                    onChange={handleChangeFilterInvoices}
                                    label="Filter by invoice type"
                                >
                                    <MenuItem value={'all'}>Show All Types</MenuItem>
                                    <MenuItem value={'memberships'}>Memberships</MenuItem>
                                    <MenuItem value={'academy'}>Academy</MenuItem>
                                    <MenuItem value={'parking'}>Parking</MenuItem>
                                </Select>
                            </FormControl>
                            <FormControl>
                                <FormControlLabel
                                    label="Unpaid"
                                    control={
                                        <Switch
                                            checked={filterInvoicesUnpaid}
                                            onChange={(event, value) => setFilterInvoicesUnpaid(value)}
                                            name="checkedB"
                                            color="primary"
                                        />
                                    }
                                />
                            </FormControl>
                            <FormControl>
                                <IconButton
                                    style={{ position: 'absolute', right: '20px', paddingTop: '8px' }}
                                    color="primary"
                                    onClick={loadAllInvoices}
                                >
                                    <AutorenewOutlinedIcon />
                                </IconButton>
                            </FormControl>
                        </Box>
                        <SectionHeading title="Invoices" />
                        <Card style={{ width: 'auto' }}>
                            <InvoicesPanel
                                invoices={allInvoices}
                                variant="customer"
                                loading={loadingAllInvoices}
                                itemActionHandler={itemActionHandler}
                                security={security}
                                pageHandler={pageHandler}
                                activeStep={allInvoicesPage}
                                hasMoreSteps={allInvoicesHasMorePage}
                                selectCustomerHandler={forceSelectCustomer}
                            />
                        </Card>
                    </Container>
                )}
                {view === 2 && isAuthenticated && <ForecastsController security={security} />}
            </Grid>
            {view === 0 && isAuthenticated && security.basic && (
                <ActionButton
                    callbackhandler={actionButtonHandler}
                    open={speedDialOpen}
                    customerId={customerId}
                    security={security}
                />
            )}
            {isAuthenticated && (security.basic || security.forecasts) && (
                <div style={{ height: 80, width: '100%' }}>
                    <BottomNavigation
                        showLabels
                        className={classes.bottomNav}
                        value={view}
                        onChange={(event, newValue) => {
                            setView(newValue);
                        }}
                    >
                        {security.basic && <BottomNavigationAction label="Search" icon={<SearchOutlined />} />}
                        {security.basic && <BottomNavigationAction label="Invoices" icon={<DescriptionOutlined />} />}
                        {security.forecasts && (
                            <BottomNavigationAction label="Forecasts" icon={<WbSunnyOutlinedIcon />} />
                        )}
                    </BottomNavigation>
                </div>
            )}
        </>
    );
}
export default AdminController;

const InvoicesPanel = (props) => {
    const {
        invoices,
        loading,
        itemActionHandler,
        security,
        variant,
        pageHandler,
        activeStep,
        hasMoreSteps,
        selectCustomerHandler,
    } = props;
    const actionHandler = (action, item) => {
        itemActionHandler(action, item);
    };

    const selectCustomerFromInvoice = (invoice) => {
        const customer = {
            customerId: invoice.customer_id,
            fullName: invoice.customer_name,
            email: invoice.email,
            mobile: '',
        };
        selectCustomerHandler(customer);
    };
    const skeletonItems = [0, 1, 2];
    return (
        <>
            {variant === 'customer' && (
                <PagingPanel
                    activeStep={activeStep}
                    hasMoreSteps={hasMoreSteps}
                    pageHandler={pageHandler}
                    loading={loading}
                />
            )}
            <List>
                {loading && (
                    <Container>
                        {skeletonItems.map((dummyItem, index) => (
                            <>
                                <Grid container direction="row" justify="space-between" alignItems="center" spacing={1}>
                                    <Grid container xs={3}>
                                        <Skeleton animation="pulse" width={50} />
                                    </Grid>
                                    <Grid item xs container alignItems="center" justify="flex-start">
                                        <p>
                                            <Skeleton animation="pulse" width={120} />
                                            <Skeleton animation="pulse" width={100} />
                                            <Skeleton animation="pulse" width={70} />
                                        </p>
                                    </Grid>
                                    <Grid item xs={2} container alignItems="center" justify="center">
                                        <Skeleton animation="pulse" width={30} height={20} />
                                    </Grid>
                                </Grid>
                                {index < skeletonItems.length - 1 && <Divider />}
                            </>
                        ))}
                    </Container>
                )}

                {!loading &&
                    invoices.map((invoice, index) => {
                        let statusColor = 'default';
                        statusColor =
                            invoice.status === 'sent' || invoice.status === 'overdue' ? 'primary' : statusColor;
                        statusColor =
                            invoice.status === 'unpaid' || invoice.status === 'overdue' ? 'secondary' : statusColor;
                        statusColor = invoice.status === 'void' || invoice.status === 'paid' ? 'default' : statusColor;
                        return (
                            <>
                                <ListItem key={index}>
                                    <ListItemText>
                                        <Grid
                                            container
                                            direction="row"
                                            justify="space-between"
                                            alignItems="center"
                                            spacing={1}
                                        >
                                            <Grid container xs={3}>
                                                <Chip
                                                    variant="outlined"
                                                    color={statusColor}
                                                    size="small"
                                                    label={invoice.status}
                                                />
                                            </Grid>
                                            <Grid item xs container alignItems="center" justify="flex-start">
                                                {variant === 'customer' && (
                                                    <>
                                                        <Link
                                                            style={{ display: 'contents' }}
                                                            onClick={() => selectCustomerFromInvoice(invoice)}
                                                        >
                                                            {' '}
                                                            {invoice.customer_name}
                                                        </Link>
                                                        <br />
                                                    </>
                                                )}
                                                {formatDate(invoice.date)} &nbsp;{invoice.invoice_number}&nbsp;&euro;
                                                {invoice.total.toFixed(2)}
                                                <br />
                                                {invoiceHasReceipt(invoice) && (
                                                    <>
                                                        {formatDate(invoice.payments[0].date)}&nbsp;
                                                        {invoice.payments[0].payment_number}
                                                    </>
                                                )}
                                            </Grid>
                                            <Grid item xs={2} container alignItems="center" justify="flex-end">
                                                {
                                                    <ItemActionButton
                                                        actionHandler={actionHandler}
                                                        actionItem={{
                                                            index: index,
                                                            invoice: {
                                                                invoice_number: invoice.invoice_number,
                                                                total: invoice.total,
                                                                status: invoice.status,
                                                                payments: invoice.payments,
                                                            },
                                                        }}
                                                        security={security}
                                                    />
                                                }
                                            </Grid>
                                        </Grid>
                                    </ListItemText>
                                </ListItem>
                                {index < invoices.length - 1 && <Divider />}
                            </>
                        );
                    })}
            </List>
            {variant === 'customer' && (
                <PagingPanel
                    activeStep={activeStep}
                    hasMoreSteps={hasMoreSteps}
                    pageHandler={pageHandler}
                    loading={loading}
                />
            )}
        </>
    );
};

const PagingPanel = (props) => {
    const { activeStep, hasMoreSteps, pageHandler, loading } = props;
    return (
        <>
            <Grid container direction="row" style={{ padding: 10, background: '#fafafa' }}>
                <Grid container item xs justify="flex-start">
                    <Button size="small" onClick={() => pageHandler('back')} disabled={activeStep === 1 || loading}>
                        <KeyboardArrowLeft />
                        Back
                    </Button>
                </Grid>
                <Grid container item xs justify="flex-end">
                    <Button size="small" onClick={() => pageHandler('next')} disabled={!hasMoreSteps || loading}>
                        Next {hasMoreSteps === true}
                        <KeyboardArrowRight />
                    </Button>
                </Grid>
            </Grid>
        </>
    );
};

const ItemActionButton = (props) => {
    const { actionHandler, actionItem, security } = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = (action) => {
        setAnchorEl(null);
        actionHandler(action, actionItem);
    };

    const useStyles = makeStyles((theme) => ({
        rootMenuItem: {
            paddingTop: 4,
            paddingBottom: 4,
            [theme.breakpoints.up('sm')]: {
                minHeight: 48,
            },
        },
    }));

    const classes = useStyles();

    return (
        <>
            <IconButton disableElevation aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
                <MoreHorizIcon />
            </IconButton>
            {/*<Menu open={Boolean(anchorEl)} onClose={handleClose} keepMounted anchorEl={anchorEl}>*/}
            <SwipeableDrawer open={Boolean(anchorEl)} onClose={handleClose} anchor="bottom">
                {(security.add_all_cashpayment || security.add_own_cashpayment) &&
                    invoiceMethodValid(actionItem.invoice, 'cashpayment') && (
                        <MenuItem
                            className={classes.rootMenuItem}
                            disabled={!invoiceCanPay(actionItem.invoice)}
                            onClick={() => handleClose('cashpayment')}
                        >
                            <ListItemIcon>
                                <LocalAtmOutlinedIcon />
                            </ListItemIcon>
                            In-person Payment ...
                        </MenuItem>
                    )}
                {security.add_jcc_payment && invoiceMethodValid(actionItem.invoice, 'jccpayment') && (
                    <MenuItem
                        className={classes.rootMenuItem}
                        disabled={!invoiceCanPay(actionItem.invoice)}
                        onClick={() => handleClose('jccpayment')}
                    >
                        <ListItemIcon>
                            <CreditCardOutlinedIcon />
                        </ListItemIcon>
                        Process JCC Payment ...
                    </MenuItem>
                )}
                {security.add_stripe_payment && invoiceMethodValid(actionItem.invoice, 'stripepayment') && (
                    <MenuItem
                        className={classes.rootMenuItem}
                        disabled={!invoiceCanPay(actionItem.invoice, 'stripepayment')}
                        onClick={() => handleClose('stripepayment')}
                    >
                        <ListItemIcon>
                            <CreditCardOutlinedIcon />
                        </ListItemIcon>
                        Process Stripe Payment ...
                    </MenuItem>
                )}
                {security.manage_parking && <Divider /> && (
                    <MenuItem
                        className={classes.rootMenuItem}
                        disabled={!invoiceCanManageParkingCards(actionItem.invoice)}
                        onClick={() => handleClose('registerparkingcards')}
                    >
                        <ListItemIcon>
                            <EmailOutlinedIcon />
                        </ListItemIcon>
                        Manage Parking Cards...
                    </MenuItem>
                )}
                <Divider />
                <MenuItem
                    className={classes.rootMenuItem}
                    disabled={!invoiceHasReceipt(actionItem.invoice)}
                    onClick={() => handleClose('emailreceipt')}
                >
                    <ListItemIcon>
                        <EmailOutlinedIcon />
                    </ListItemIcon>
                    Email Receipt
                </MenuItem>
                <Divider />
                {security.basic && (
                    <MenuItem
                        className={classes.rootMenuItem}
                        disabled={invoiceIsVoid(actionItem.invoice)}
                        onClick={() => handleClose('previewinvoice')}
                    >
                        <ListItemIcon>
                            <VisibilityOutlinedIcon />
                        </ListItemIcon>
                        Preview Invoice
                    </MenuItem>
                )}
                {security.basic && (
                    <MenuItem
                        className={classes.rootMenuItem}
                        disabled={invoiceIsVoid(actionItem.invoice)}
                        onClick={() => handleClose('invoicelink')}
                    >
                        <ListItemIcon>
                            <LinkOutlinedIcon />
                        </ListItemIcon>
                        Get Invoice Link
                    </MenuItem>
                )}
                {security.basic && (
                    <MenuItem
                        className={classes.rootMenuItem}
                        disabled={invoiceIsVoid(actionItem.invoice)}
                        onClick={() => handleClose('emailinvoice')}
                    >
                        <ListItemIcon>
                            <EmailOutlinedIcon />
                        </ListItemIcon>
                        Email Invoice
                    </MenuItem>
                )}
            </SwipeableDrawer>
            {/*</Menu>*/}
        </>
    );
};

const formatDate = (date) => {
    const d = new Date(date);
    return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
};

const invoiceCanPay = (invoice, method) => {
    if (invoice.status === 'sent' || invoice.status === 'overdue' || invoice.status === 'unpaid') {
        return true;
    }
    if (
        invoice.status === 'paid' &&
        (invoiceIsAcademy(invoice) || invoiceIsParking(invoice)) &&
        method === 'stripepayment'
    ) {
        return true;
    }
    return false;
};

const invoiceHasReceipt = (invoice) => {
    if (invoice.status === 'paid' && invoice.payments && invoice.payments.length > 0) {
        return true;
    }
    return false;
};
const invoiceIsVoid = (invoice) => {
    if (invoice.status === 'void') {
        return true;
    }
    return false;
};
const invoiceIsAcademy = (invoice) => {
    return invoice.invoice_number.substr(0, 2) === 'A-';
};
const invoiceIsParking = (invoice) => {
    return invoice.invoice_number.substr(0, 2) === 'P-';
};
const invoiceMethodValid = (invoice, method) => {
    if (method === 'cashpayment') {
        return true;
    }
    if (invoiceIsAcademy(invoice) || invoiceIsParking(invoice)) {
        if (method === 'stripepayment') {
            return true;
        }
    } else {
        if (method === 'jccpayment') {
            return true;
        }
    }
    return false;
};
const invoiceCanManageParkingCards = (invoice) => {
    return invoiceIsParking(invoice) && invoiceHasReceipt(invoice);
};
const PageHeader = (props) => {
    const { authenticationHandler, searchbar, security, apiDomain } = props;
    return (
        <>
            <AppBar position="static">
                <Toolbar style={{ padding: 10 }}>
                    <Grid container direction="row" justify="space-between" alignItems="center" spacing={1}>
                        <Grid item>
                            <img src="icon.png" alt="Nicosia Sailing Club logo"></img>
                        </Grid>
                        <Grid item xs container alignItems="center" justify="flex-start">
                            <Typography variant="h6">Nicosia Sailing Club</Typography>
                        </Grid>
                        <Grid item xs={2} container alignItems="center" justify="flex-end">
                            {/*<AdminLogin authenticationHandler={authenticationHandler} security={security} apiDomain={apiDomain}></AdminLogin>*/}
                            <AdminLogin_new
                                authenticationHandler={authenticationHandler}
                                security={security}
                                apiDomain={apiDomain}
                            ></AdminLogin_new>
                        </Grid>
                    </Grid>
                </Toolbar>
            </AppBar>
        </>
    );
};

const SectionHeading = (props) => {
    const { title } = props;
    return (
        <>
            <div style={{ margin: 10, marginTop: 20 }}>
                <Typography variant="h6" style={{ color: 'gray' }}>
                    {title}
                </Typography>
            </div>
        </>
    );
};
